import { render, staticRenderFns } from "./TabBriefcase.vue?vue&type=template&id=660e5ae6&"
import script from "./TabBriefcase.vue?vue&type=script&lang=js&"
export * from "./TabBriefcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports